import type { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import Col from "react-bootstrap/Col";
import React from "react";
import Form from "react-bootstrap/Form";
import { formatDateTime } from "utils/localizations";
import type CreateExemptionViewModel from "viewModels/callCenter/search/exemptions/createExemption/createExemptionViewModel";
import AlertWithIcon from "views/common/alertWithIcon";

export const CreateExemptionPreviewSection: ViewComponent<CreateExemptionViewModel> = observer(({ vm }) => {
  const fuelType = vm.exemptionPreview.vehicleClassifiedFuelType;

  return (
    <>
      <div className="bg-light mb-4 px-4 pt-4 rounded">
        <Form.Row>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translateAttribute("licensePlate", "countryId")}</Form.Label>
            <div>{vm.translateCountryId(vm.exemptionPreview.vehicle?.countryId)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translateAttribute("licensePlate", "licensePlate")}</Form.Label>
            <div>{vm.exemptionPreview.vehicle?.licensePlate}</div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translateAttribute("exemption", "validSinceDate")}</Form.Label>
            <div className="text-nowrap">{formatDateTime(vm.exemptionPreview.validSince)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translateAttribute("exemption", "validUntilDate")}</Form.Label>
            <div className="text-nowrap">{formatDateTime(vm.exemptionPreview.validUntil)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={12} xs={12}>
            <Form.Label>{vm.translateAttribute("exemption", "exemptionReasonId")}</Form.Label>
            <div>{vm.getExemptionReason(vm.exemptionPreview.exemptionReasonId)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={12} xs={12}>
            <Form.Label>{vm.translateAttribute("exemption", "officialRecordId")}</Form.Label>
            <div className="text-break">{vm.exemptionPreview.officialRecordId}</div>
          </Form.Group>
        </Form.Row>
      </div>
      <div className="mb-4">
        {vm.rejectedReasonText && <AlertWithIcon variant="danger">{vm.rejectedReasonText}</AlertWithIcon>}
        {vm.warningReasons?.map(reason => (
          <AlertWithIcon key={reason} variant="warning">
            {vm
              .translatePreview(`warningReason.${reason}`)
              .replace("%fuel_type%", fuelType ? vm.translateClassifiedFuelType(fuelType) : "")}
          </AlertWithIcon>
        ))}
      </div>
    </>
  );
});

export default CreateExemptionPreviewSection;
